<script lang="ts" setup>
import { formatValue } from '@forgd/formatter'
import { Badge } from '@forgd/ui-kit/badge'
import { Button } from '@forgd/ui-kit/button'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import { useQuery } from '@pinia/colada'

// Header-only query — same cache key as children, deduped by pinia/colada.
const priceChangeQuery = useQuery({
  ...buildApiQuerySSRSafe('/public-research/price-change-vs-initial-circ-supply', {
    params: () => ({ query: {} }),
  }),
  refetchOnWindowFocus: false,
})

const analyzingCount = computed(() => priceChangeQuery.data.value?.tokensQty ?? 0)
</script>

<template>
  <section class="flex flex-col gap-5">
    <header class="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-5">
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2">
          <h2 class="text-sm font-semibold text-primal">
            Tokenomics Intelligence
          </h2>
          <Badge v-if="analyzingCount">
            {{ formatValue(analyzingCount, 'string:plural,Project') }} Avg.
          </Badge>
        </div>
        <p class="text-xs text-secondary">
          Distributions, emissions, performance, &amp; launch setup.
        </p>
      </div>
      <Button as-child variant="outline" size="sm" class="self-start sm:self-end">
        <NuxtLink to="/research/tokenomics">
          View Live Report
          <ArrowRightIcon aria-hidden="true" />
        </NuxtLink>
      </Button>
    </header>

    <PrOverviewTokenomicsTopMetrics />

    <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <PrOverviewTokenomicsAllocationCard />
      <PrOverviewTokenomicsFdvCharts />
    </div>
  </section>
</template>
